<div class="sidebar-balance-box">
  <div class="d-flex justify-content-between align-items-center balance-box-holder bg-primary-p9 text-white px-10 py-15"
    [ngClass]="{'balance-prepaid cp': (user?.paymentType === 'PREPAID' || user?.role ==='admin') && user?.role !== 'subaccount'}"
    (click)="onBalanceWidgetClick()">
    <div class="box-title">
      <span>Balance:</span> € {{currentValue}}
    </div>
    <div *ngIf="user?.enabled && isBillingAvailableForUser" class="text-end">
      <a *ngIf="user?.paymentType === 'PREPAID' || user?.role ==='admin'" class="link-icon">
        <i class="fas fa-plus"></i>
      </a>
    </div>
  </div>
  <a *ngIf="(user?.paymentType === 'PREPAID' || user?.role ==='admin') && isBillingAvailableForUser" [routerLink]="['/billing/prepaid']" class="topup-box-sm bg-accent-a2 block text-white"
    [tooltip]="'Balance: €' + currentValue">
    <span class="icon-payments"></span>
  </a>
</div>
